import z from "zod";

import { scheduleInputSchema } from "@ses-mams/validation";

export const myScheduleFormSchema = z.object({
  schedule: scheduleInputSchema,
});

export type MyScheduleFormSchema = z.infer<typeof myScheduleFormSchema>;
